import get from 'lodash.get';
import { Box, Text } from 'wix-style-react';
import * as React from 'react';
import css from './RecurringInvoicesView.scss';
import { translate } from 'react-i18next';
import { frequencyTranslations } from '../RecurringPayView/RecurringPayView';
import { currencyFormat, newMobileViewBreakpoint } from '../../core';
import { isMobileView } from '../../core/isMobileView';
import { WithRecurringViewLoader } from '../loaders/loaders-builder';
import RecurringDetailsCard, { PaymentType } from './RecurringDetailsCard/RecurringDetailsCard';
var RecurringInvoiceView = function (_a) {
    var invoice = _a.invoice, recurringStandaloneViewEnabled = _a.recurringStandaloneViewEnabled, darkView = _a.darkView, _b = _a.newMobileView, newMobileView = _b === void 0 ? false : _b, t = _a.t;
    var currencyCode = invoice.currencyCode, _c = invoice.metaData.sourceProperties, billingCycle = _c.billingCycle, numberOfBillingCycles = _c.numberOfBillingCycles, frequency = _c.frequency;
    var invoiceAmount = get(invoice, 'totals.total.serializedValue', 0);
    var currency = currencyFormat({
        currency: currencyCode,
        locale: invoice.locale.language,
    });
    var isUnlimitedBilling = numberOfBillingCycles === '0';
    var darkBackgroundColorIfNeeded = !recurringStandaloneViewEnabled && darkView ? css.containerDarkBgColor : '';
    var textSize = isMobileView() || newMobileView ? 'tiny' : 'small';
    var titleWeight = newMobileView ? 'thin' : 'normal';
    var valueWeight = newMobileView ? 'normal' : 'bold';
    var maxWidth = newMobileView ? newMobileViewBreakpoint : '';
    return (React.createElement("div", { "data-hook": "recurring-section", className: "".concat(css.container, " ").concat(darkBackgroundColorIfNeeded), style: newMobileView
            ? {
                backgroundColor: 'white',
                paddingLeft: '5%',
                paddingRight: '5%',
                paddingBottom: '18px',
                paddingTop: '18px',
                maxWidth: maxWidth,
            }
            : {
                width: '867px',
            } }, recurringStandaloneViewEnabled ? (React.createElement(RecurringDetailsCard, { paymentType: PaymentType.AUTOMATIC, recurringPayment: parseFloat(billingCycle), totalRecurringPayments: parseFloat(numberOfBillingCycles), billingCycle: frequency })) : (React.createElement(Box, { dataHook: "recurring-details-section", direction: "vertical", maxWidth: maxWidth },
        React.createElement("div", { className: css.row, "data-hook": "payments-row", style: { maxWidth: maxWidth } },
            React.createElement(Text, { light: darkView, size: textSize, weight: titleWeight, dataHook: "payments-title", secondary: !darkView }, "".concat(t('recurring-payment-uou.title'), " ")),
            React.createElement(Text, { light: darkView, size: textSize, weight: valueWeight, dataHook: "payments-value" }, isUnlimitedBilling
                ? t('recurring-payment-uou.title.unlimited', { billingCycle: billingCycle })
                : t('recurring-payment-uou.title.limited', {
                    billingCycle: billingCycle,
                    numberOfBillingCycles: numberOfBillingCycles,
                }))),
        React.createElement("div", { className: css.row },
            React.createElement(Text, { light: darkView, size: textSize, weight: titleWeight, dataHook: "amount-title", secondary: !darkView }, "".concat(t('invoice.view.recurring.amount.title'), " ")),
            React.createElement(Text, { light: darkView, size: textSize, weight: valueWeight, dataHook: "amount-value" }, currency(invoiceAmount || 0))),
        React.createElement("div", { className: css.row },
            React.createElement(Text, { light: darkView, size: textSize, weight: titleWeight, dataHook: "cycle-title", secondary: !darkView }, "".concat(t('invoice.view.recurring.cycle.title'), " ")),
            React.createElement(Text, { light: darkView, size: textSize, weight: valueWeight, dataHook: "cycle-value" }, t(frequencyTranslations[frequency.toLocaleLowerCase()])))))));
};
export default WithRecurringViewLoader(translate(['invoice-view', 'locale-data'], { wait: true })(RecurringInvoiceView));
//# sourceMappingURL=RecurringInvoicesView.js.map